var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "VDebug"
  }, [_c("a-spin", {
    attrs: {
      tip: "调试中...",
      spinning: _vm.debugLoading
    }
  }, [_c("ul", {
    staticClass: "interface-api"
  }, [_c("li", {
    staticClass: "api-right"
  }, [_c("ol", [_c("li", {
    staticClass: "api-result"
  }, [_c("div", {
    staticClass: "subTitle"
  }, [_vm._v("返回结果")]), _c("div", {
    staticClass: "result"
  }, [Object.keys(_vm.debugResponseJSON).length !== 0 ? _c("json-viewer", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      value: _vm.debugResponseJSON,
      "expand-depth": 1000,
      boxed: "",
      sort: "",
      copyable: _vm.copyable,
      theme: "my-awesome-json-theme"
    }
  }) : _c("div", {
    staticClass: "nodata"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/service/openAI/nodata.png"),
      alt: ""
    }
  }), _c("span", {
    staticClass: "desc-1"
  }, [_vm._v("暂无调用结果")]), _c("span", {
    staticClass: "desc-2"
  }, [_vm._v("发送调用请求后，可在此获取调用结果")])])], 1)])])])])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };